import React, { useState } from 'react';

const NumberOfDaysSupplyInput = ({ column, dispatch, value, rowData, maxValue = 30 }) => {

    const [error, setError] = useState(null);

    const validateDaysSupply = (value) => {
        return !isNaN(value) && value >= 1 && value <= maxValue;
    };

    const handleBlur = async (value) => {
        const error = !validateDaysSupply(value)
            ? `Days Supply should be in between 1 and `+ maxValue
            : null;

        setError(error);
        dispatch({
            type: 'UpdateCellValue',
            rowKeyValue: rowData.rxf_id,
            columnKey: column.key,
            value: value,
            cellComponentType: 'DaysSupplyInput'
        });
    };

    return (
         <div className="flex-col group relative">
         {/* <div className="group relative"> */}
            <span className="relative">
                <input
                    type="number"
                    min="1"
                    autoComplete="off"
                    id={`days_supply_${rowData.id}`}
                    name="days_supply"
                    defaultValue={value}
                    placeholder="Days Supply"
                    onChange={(e) => handleBlur(e.currentTarget.value)}
                    className={`border focus:outline-none focus:none h-10 rounded-md pl-3 text-sm font-normal w-full ${error ? 'border-red-500' : 'border-gray-300'
                        }`}
                />
            </span>
            {
                error && (
                        <p className="text-xs md:text-sm md:pt-1 text-hlred">
                            {error}
                        </p>
                )
            }
            
            
        </div>
    );
};

export default NumberOfDaysSupplyInput;